/**
 * Shared constants for the TEFAS API client
 */

/**
 * Default maximum number of days per request window when splitting history calls
 */
export const DEFAULT_MAX_DAYS_PER_REQUEST = 90;

/**
 * TEFAS API endpoint for fund allocation/portfolio composition data
 */
export const TEFAS_ALLOCATION_ENDPOINT = '/api/DB/BindHistoryAllocation';


